export type PortfolioDetailsTabs = (typeof PortfolioDetailsTabs)[keyof typeof PortfolioDetailsTabs];
export const PortfolioDetailsTabs = {
	OVERVIEW: "OVERVIEW",
	COMPOSITION: "COMPOSITION",
	COMMENTARY: "COMMENTARY",
	SCENARIO_ANALYSIS: "SCENARIO_ANALYSIS",
	PORTFOLIO_STUDIO_SETTINGS: "PORTFOLIO_STUDIO_SETTINGS",
};
